import React, { useState, useEffect } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import supabase from '../supabase';

export default function Health() {
  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchMetrics() {
      const { data, error } = await supabase
        .from('health_metrics')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(200);
      if (error) { setError(error.message); setLoading(false); return; }
      setMetrics(data || []);
      setLoading(false);
    }
    fetchMetrics();
  }, []);

  if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

  const cols = metrics.length > 0
    ? Object.keys(metrics[0]).filter(k => k !== 'id' && k !== 'user_id')
    : [];

  // Highlight the most recent row per metric
  const latestIds = new Set();
  const seen = new Set();
  for (const m of metrics) {
    if (!seen.has(m.metric)) {
      latestIds.add(m.id);
      seen.add(m.metric);
    }
  }

  return (
    <div>
      <div className="page-header">
        <h1>Health Metrics</h1>
        <p>{metrics.length} entries</p>
      </div>

      {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}

      {metrics.length === 0 ? (
        <div className="d-card"><p style={{ color: 'var(--text-muted)', margin: 0 }}>No health metrics recorded.</p></div>
      ) : (
        <div className="d-card" style={{ overflowX: 'auto', padding: 0 }}>
          <table className="d-table">
            <thead>
              <tr>{cols.map(c => <th key={c}>{c.replace(/_/g, ' ')}</th>)}</tr>
            </thead>
            <tbody>
              {metrics.map(row => (
                <tr
                  key={row.id}
                  style={latestIds.has(row.id)
                    ? { background: 'rgba(79,126,255,0.07)', borderLeft: '2px solid var(--accent)' }
                    : {}}
                >
                  {cols.map(c => (
                    <td key={c}>{formatCell(row[c])}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function formatCell(val) {
  if (val === null || val === undefined) return <span style={{ color: 'var(--text-muted)' }}>—</span>;
  if (typeof val === 'boolean') return val ? <span className="pill pill-success">yes</span> : <span className="pill pill-muted">no</span>;
  if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}T/)) return new Date(val).toLocaleString();
  if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}$/)) return new Date(val + 'T00:00:00').toLocaleDateString();
  return String(val);
}
